import dayjs from 'dayjs'
import { formatMessage } from '../constants/strings/intl/intlHooks'
import { messages } from '../constants/strings/messages'
import { shortMonth } from '../constants/shortMonth'

export const onlyNumberString = (text: string) => {
  return text.match(/\d/g)!.join('')
}

export const loginStringToFloat = (text: string) => {
  return parseFloat(text.substr(3, 7))
}

export const formatValueToCurrency = (inputValue: number) => {
  if (!inputValue) {
    return '—'
  }
  let value = inputValue.toFixed(2)

  value = value.replace('.', ',')

  //thousand separation inclusion
  const pattern = /(-?\d+)(\d{3})/
  while (pattern.test(value)) {
    value = value.replace(pattern, '$1.$2')
  }

  return `R$ ${value}`
}

export const truncate = (value: number) => {
  if (value === undefined || value === null) {
    return ''
  }

  return value.toFixed(0)
}

export const getOnlyNumbers = (value: string) => {
  return value.replace(/\D/g, '')
}

export const ifMoneyInt = (value: any) => {
  if (Number.isInteger(value)) {
    return `R$${value},00`
  } else {
    if (value.toString().includes('.')) {
      const fixedValue = value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      return `R$${fixedValue.replace('.', ',')}`
    }
    return `R$${value}`
  }
}

export const formatDate = (value: string) => {
  const year = value.split('-')[0]
  const month = value.split('-')[1]
  const day = value.split('-')[2]

  return day.slice(-2) + '/' + month.slice(-2) + '/' + year
}

export const formatDateWithMonthAndYear = (date: Date) => {
  return dayjs(date).format('MM/YYYY')
}

export const formatDateWithShortMonthName = (input: number | Date) => {
  //TODO: Investigate bugs related to dayjs formatting
  const date = typeof input === 'number' ? new Date(input) : input

  return dayjs(input).format(`DD ${shortMonth[date?.getMonth()]} YYYY`)
}

export const formatDateWithMonthName = (input: number | Date) => {
  const date = typeof input === 'number' ? new Date(input) : input

  return `${date?.getDate()} ${shortMonth[date?.getMonth()]} ${date?.getFullYear()}`
}

export const formatEventDateTime = (date: string, time: string) => {
  return `${date} ${formatMessage(messages.event_DateTime_separator)} ${time}${formatMessage(
    messages.event_DateTime_hour
  )}`
}

export const formatConfidentialCPF = (cpf: string | undefined): string => {
  if (!cpf) {
    return ' '
  }

  let visibleCPFDigits = ' '
  let formattedConfidentialCPF = ' '

  const pattern = /(\d{11})|(\d{3}\.\d{3}\.\d{3}-\d{2})/

  if (pattern.test(cpf)) {
    visibleCPFDigits = cpf.slice(0, 3)
    formattedConfidentialCPF = `${visibleCPFDigits}.***.***-**`
  }

  return formattedConfidentialCPF
}

export const formatDateToBarcode = (barcode: string) => {
  const dateBase = new Date(1997, 9, 7)
  const daysInBarCode = Number(barcode.substr(33, 4))
  return new Date(dateBase.setDate(dateBase.getDate() + daysInBarCode))
}
